import { useAdminMode } from "@/contexts/admin-mode-provider";
import { useTeams } from "@/contexts/teams-provider";

export const ToggleAdminMode = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isAdmin } = useTeams();
  const { isAdminMode } = useAdminMode();

  if (!isAdmin || !isAdminMode) {
    return <></>;
  }

  return <>{children}</>;
};
